<template>
  <div class="footer">
    <p class="mb60">
      如果您需要了解更多信息或对我们的产品有任何疑问，
      请随时联系我们，我们将竭诚为您服务
    </p>
    <p>福昕智慧打印客服专员</p>
    <p>在线客服QQ：800802977</p>
    <p>服务时间：工作日9:00-18:00</p>
    <div class="imgContainer">
      <PreViewImage
        class="img"
        :src="require('../../../assets/img/guide/oaQrcode.png')"
      />
    </div>
    <p class="tips">福昕智慧打印公众号</p>
  </div>
</template>

<script>
import PreViewImage from "./PreViewImage.vue";

export default {
  components: {
    PreViewImage
  }
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  padding-bottom: 75px;
}

p {
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #666666;
  line-height: 44px;
}

.imgContainer {
  width: 315px;
  height: 315px;
  border: solid 2px #dddddd;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 45px auto 20px;
}

.img {
  width: 299px;
}

.mb60 {
  margin-bottom: 60px;
}

.tips {
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #999999;
  line-height: 24px;
  width: 100%;
  text-align: center;
}
</style>
